/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface EmploymentPeriodDTO
 */
export interface EmploymentPeriodDTO  {
    /**
     * 
     * @type {number}
     * @memberof EmploymentPeriodDTO
     */
    id?: number;
    /**
     * 
     * @type {Date}
     * @memberof EmploymentPeriodDTO
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof EmploymentPeriodDTO
     */
    endDate?: Date;
}

/**
 * Check if a given object implements the EmploymentPeriodDTO interface.
 */
export function instanceOfEmploymentPeriodDTO(value: object): value is EmploymentPeriodDTO {
    return true;
}

export function EmploymentPeriodDTOFromJSON(json: any): EmploymentPeriodDTO {
    return EmploymentPeriodDTOFromJSONTyped(json, false);
}

export function EmploymentPeriodDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmploymentPeriodDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
                'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
    };
}

export function EmploymentPeriodDTOToJSON(json: any): EmploymentPeriodDTO {
    return EmploymentPeriodDTOToJSONTyped(json, false);
}

export function EmploymentPeriodDTOToJSONTyped(value?: EmploymentPeriodDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'startDate': value['startDate']?.toISOString(),
        'endDate': value['endDate']?.toISOString(),
    };
}


